const messages = {
  es: {
    translations: {
      signup: {
        title: "Registro",
        toasts: {
          success: "¡Usuario creado exitosamente!",
          fail: "Error al crear usuario. Comprueba los datos proporcionados.",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Registrar",
          login: "¿Ya tienes una cuenta? ¡Inicia sesión!"
        },
      },
      login: {
        title: "Iniciar Sesión",
        form: {
          email: "Correo Electrónico",
          password: "Contraseña",
        },
        buttons: {
          submit: "Acceder",
          register: "¿No tienes una cuenta? ¡Regístrate!",
        },
      },
      companies: {
        title: "Registrar Empresa",
        form: {
          name: "Nombre de la empresa",
          plan: "Departamento",
          token: "Token",
          submit: "Registrar",
          success: "¡Empresa creada con éxito!",
        },
      },
      auth: {
        toasts: {
          success: "¡Inicio de sesión exitoso!",
        },
        token: "Token",
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Servicios hoy: ",
          },
        },
      },
      connections: {
        title: "Conexiones",
        toasts: {
          deleted: "¡Conexión eliminada con éxito!",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? ¡Esta acción no se puede revertir!",
          disconnectTitle: "Desconectar",
          disconnectMessage: "¿Estás seguro? Tendrás que escanear el código QR de nuevo.",
        },
        buttons: {
          add: "Agregar WhatsApp",
          disconnect: "Desconectar",
          tryAgain: "Intentar de nuevo",
          qrcode: "Código QR",
          newQr: "Conectar",
          connecting: "Conectando",
          ConfirmDeleting: "Desconectar",
          edit: "Editar",
          recoverCloud: "Recuperar",
        },
        sessionInvalidated: {
          cloud:
            "La conexión Cloud con Meta expiró o fue revocada. Ve a Conexiones y pulsa Recuperar para autorizar de nuevo con Meta.",
          baileys:
            "Tu sesión de WhatsApp fue cerrada desde el teléfono. Para seguir enviando mensajes, vuelve a vincular el dispositivo escaneando el código QR.",
        },
        toolTips: {
          cloudApi: {
            disconnected: {
              title: "WhatsApp Cloud desconectado",
              content: "Autoriza de nuevo con Meta (Embedded Signup) para restaurar el token y la línea WABA. No uses código QR.",
            },
            pending: {
              title: "Configuración Cloud pendiente",
              content: "Completa Embedded Signup con Meta para vincular tu número y token de WhatsApp Business API.",
            },
            connected: {
              title: "WhatsApp Cloud conectado",
              content: "La línea Cloud está activa vía Meta API (WABA y token válidos).",
            },
            invalid: {
              title: "Sesión Cloud inválida",
              content: "El token expiró o fue revocado. Usa Recuperar para reconectar con Meta.",
            },
            quality: {
              green: {
                title: "Calidad del número: buena",
                content: "Meta reporta calidad GREEN para esta línea Cloud.",
              },
              yellow: {
                title: "Calidad del número: atención",
                content:
                  "Meta reporta calidad YELLOW. Revisa plantillas, bloqueos y volumen de envío en Meta Business Suite antes de que la línea se limite.",
              },
              red: {
                title: "Calidad del número: riesgo",
                content:
                  "Meta reporta calidad RED. Hay riesgo de que la línea deje de enviar mensajes. Revisa el estado del número en Meta Business Suite y corrige las causas señaladas por Meta.",
              },
              limit: "Límite de mensajería: {{limit}}",
              openMeta: "Abrir Meta Business Suite",
            },
          },
          disconnected: {
            title: "Falló la conexión con WhatsApp",
            content: "Asegúrate de que tu teléfono esté conectado a internet y vuelve a intentarlo, o solicita un nuevo código QR"
          },
          qrcode: {
            title: "Esperando lectura del código QR",
            content: "Haz clic en el botón 'Código QR' y escanea el código QR con tu teléfono para iniciar la sesión"
          },
          connected: {
            title: "¡Conexión establecida!"
          },
          timeout: {
            title: "Se perdió la conexión con el teléfono",
            content: "Asegúrate de que tu teléfono esté conectado a internet y WhatsApp esté abierto, o haz clic en el botón 'Desconectar' para obtener un nuevo código QR"
          }
        },
        table: {
          name: "Nombre",
          status: "Estado",
          lastUpdate: "Última actualización",
          default: "Predeterminado",
          actions: "Acciones",
          session: "Sesión",
        },
      },
      whatsappModal: {
        title: {
          add: "Agregar Whatsapp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nombre",
          default: "Marcar como predeterminado",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "WhatsApp se guardó correctamente.",
      },
      qrCode: {
        message: "Escanea el QrCode para iniciar la sesión",
      },
      contacts: {
        title: "Contactos",
        searchPlaceholder: "Buscar...",
        confirmationModal: {
          deleteTitle: "Eliminar",
          importTitle: "Importar contactos",
          deleteMessage:
            "¿Estás seguro de que deseas eliminar este contacto? Se perderán todos los servicios relacionados.",
          importMessage: "¿Quieres importar todos los contactos desde tu teléfono?",
        },
        buttons: {
          import: "Importar Contactos",
          importExcel: "Importar desde Excel",
          importPhone: "Importar desde el teléfono",
          add: "Agregar Contacto",
        },
        table: {
          name: "Nombre",
          whatsapp: "WhatsApp",
          email: "Correo Electrónico",
          actions: "Acciones",
        },
        toasts: {
          importSuccess: "Contactos importados correctamente.",
          deleted: "¡Contacto eliminado exitosamente!",
          importError: "Error al importar contactos."
        }
      },
      contactModal: {
        title: {
          add: "Agregar Contacto",
          edit: "Editar Contacto",
        },
        form: {
          mainInfo: "Detalles del Contacto",
          extraInfo: "Información Adicional",
          name: "Nombre",
          number: "Número de Whatsapp",
          email: "Correo Electrónico",
          extraName: "Nombre del campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Añadir información",
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: "Contacto guardado exitosamente.",
      },
      queueModal: {
        title: {
          add: "Agregar departamentos",
          edit: "Editar departamentos",
        },
        form: {
          name: "Nombre",
          color: "Color",
          greetingMessage: "Mensaje de saludo",
          complationMessage: "Mensaje de finalización",
          outOfHoursMessage: "Mensaje fuera de horario",
          ratingMessage:  "Mensaje de valoración" ,
          token: "Token",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Agregar usuario",
          edit: "Editar usuario",
        },
        form: {
          name: "Nombre",
          email: "Correo Electrónico",
          password: "Contraseña",
          profile: "Perfil",
          language: "Idioma",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Usuario guardado exitosamente.",
      },
      scheduleModal: {
        title: {
          add: "Nuevo horario",
          edit: "Editar horario",
        },
        form: {
          body: "Mensaje",
          contact: "Contacto",
          sendAt: "Fecha de programacion",
          sentAt: "Fecha de envío",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Mensaje guardado exitosamente.",
        cloudWindow: {
          title: "No se puede programar este mensaje",
          bodyNoInbound:
            "En WhatsApp Cloud no puedes programar texto si el cliente aún no ha escrito. Espera un mensaje del cliente o usa una plantilla aprobada.",
          bodyExpiresBeforeSend:
            "La ventana de 24 h cierra el {{expiry}}. Elige una hora anterior o espera un mensaje del cliente.",
          blocked:
            "No se puede programar texto en WhatsApp Cloud: la ventana de 24 h no cubre la hora elegida.",
        },
        messengerWindow: {
          title: "No se puede programar este mensaje",
          bodyNoInbound:
            "En Messenger no puedes programar texto si el cliente aún no ha escrito. Espera un mensaje del cliente.",
          bodyExpiresBeforeSend:
            "La ventana de 24 h cierra el {{expiry}}. Elige una hora anterior o espera un mensaje del cliente.",
          blocked:
            "No se puede programar texto en Messenger: la ventana de 24 h no cubre la hora elegida.",
        },
        instagramWindow: {
          title: "No se puede programar este mensaje",
          bodyNoInbound:
            "En Instagram no puedes programar texto si el cliente aún no ha escrito. Espera un mensaje del cliente.",
          bodyExpiresBeforeSend:
            "La ventana de 24 h cierra el {{expiry}}. Elige una hora anterior o espera un mensaje del cliente.",
          blocked:
            "No se puede programar texto en Instagram: la ventana de 24 h no cubre la hora elegida.",
        },
      },
      tagModal: {
        title: {
          add: "Nueva etiqueta",
          edit: "Editar etiqueta",
          addKanban: "Nuevo etapa",
          editKanban: "Editar etapa",
        },
        form: {
          name: "Nombre",
          color: "Color",
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar",
        },
        success: "Etiqueta guardada exitosamente.",
        successKanban: "Etapa guardada con éxito.",
      },
      kanban: {
        title: "Embudos",
        searchPlaceholder: "Buscar",
        subMenus: {
          list: "Panel",
          tags: "Etapas - deprecable"
        }
      },
      tagsKanban: {
        title: "Etapas",
        laneDefault: "Tickets",
        confirmationModal: {
            deleteTitle: "Borrar etapa",
            deleteMessage: "¿Estás seguro de que desea borrar esta etapa?",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Tickets",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva etapa",
        },
        toasts: {
          deleted: "Etapa eliminada con éxito.",
        },
      },
      chat: {
        noTicketMessage: "Seleccione un ticket para comenzar a chatear.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop: "ARRASTRA Y SUELTA ARCHIVOS EN EL CAMPO A CONTINUACIÓN",
          titleFileList: "Lista de archivos"
        },
      },
      ticketsManager: {
        buttons: {
          newTicket: "Nuevo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Departamentos",
      },
      tickets: {
        toasts: {
          deleted: "El servicio en el que estabas ha sido eliminado.",
        },
        notification: {
          message: "Mensaje de",
        },
        tabs: {
          open: { title: "Bandeja" },
          closed: { title: "Resuelto" },
          search: { title: "Buscar" },
        },
        search: {
          placeholder: "Nombre, número.",
        },
        buttons: {
          showAll: "Todo",
          apply: "Aplicar",
          clear: "Limpiar",
        },
        filters: {
          title: "Filtros",
          tags: "Etiquetas",
          users: "Usuarios",
          status: "Estado",
          dateFrom: "Desde",
          dateTo: "Hasta",
          allStatus: "Todos",
          open: "Abierto",
          pending: "Pendiente",
          closed: "Cerrado",
        },
      },
      transferTicketModal: {
        title: "Transferir chat",
        fieldLabel: "Escribe para buscar usuarios",
        fieldQueueLabel: "Transferir a departamentos",
        fieldQueuePlaceholder: "Seleccione una cola",
        noOptions: "No se encontraron usuarios con ese nombre",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "En espera",
        assignedHeader: "Activos",
        unreadHeader: "No leídos",
        noTicketsTitle: "¡Nada aquí!",
        noTicketsMessage:
          "No se encontró ningún servicio con este estado o término de búsqueda",
        buttons: {
          accept: "Aceptar",
        },
      },
      newTicketModal: {
        title: "Nuevo chat",
        fieldLabel: "Buscar contacto",
        add: "Agregar",
        buttons: {
          ok: "Guardar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Analítica",
          connections: "Conexiones",
          tickets: "Chats",
          todolist: "Tareas",
          quickMessages: "Respuestas rápidas",
          whatsappTemplates: "Plantillas WhatsApp",
          contacts: "Contactos",
          queues: "Departamentos",
          tags: "Etiquetas",
          administration: "Configuración",
          users: "Equipo",
          settings: "Ajustes",
          helps: "Ayuda",
          messagesAPI: "API",
          schedules: "Programar mensajes",
          campaigns: "Marketing",
          annoucements: "Boletines",
          chats: "Chat interno",
          financeiro: "Mi suscripción",
          kanban: "Embudos",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Salir",
          },
        },
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensaje",
          token: "Token registrado",
        },
        mediaMessage: {
          number: "Número",
          body: "Nombre del archivo",
          media: "Archivo",
          token: "Token registrado",
        },
      },
      notifications: {
        noTickets: "No hay notificaciones.",
      },
      quickMessages: {
        title: "Respuestas rápidas",
        table:{
          shortcode:"Atajo",
          message:"Mensaje"
        },
        buttons: {
          add: "Nueva respuesta",
        },
        dialog: {
          shortcode: "Atajo",
          message: "Respuesta",
        },
        toasts: {
          success: "Respuesta guardada con éxito.",
          successEdit: "Respuesta actualizada con éxito.",
          successDelete: "Respuesta eliminada con éxito.",
        },
      },
      whatsappTemplates: {
        title: "Plantillas WhatsApp Cloud",
        emptyLines: "Conecta una línea WhatsApp Cloud para gestionar plantillas.",
        table: {
          name: "Nombre",
          language: "Idioma",
          category: "Categoría",
          status: "Estado",
          preview: "Vista previa",
        },
        categories: {
          UTILITY: "Utilidad",
          MARKETING: "Marketing",
          AUTHENTICATION: "Autenticación",
        },
        templateLanguages: {
          pt_BR: "Português (BR)",
          en_US: "English (US)",
          es_MX: "Español (México)",
          legacy: "{{code}} (idioma guardado)",
        },
        status: {
          DRAFT: "Borrador",
          PENDING: "Pendiente",
          APPROVED: "Aprobada",
          REJECTED: "Rechazada",
          PAUSED: "Pausada",
          DISABLED: "Deshabilitada",
        },
        buttons: {
          add: "Nueva plantilla",
          sync: "Sincronizar con Meta",
          save: "Guardar",
          cancel: "Cancelar",
          submit: "Enviar a Meta",
          preview: "Ver plantilla",
        },
        preview: {
          close: "Cerrar",
          readOnlyHint:
            "Vista previa de solo lectura. Las variables aparecen como marcadores.",
        },
        dialog: {
          addTitle: "Crear plantilla",
          editTitle: "Editar plantilla",
          subtitle: "Crea una plantilla y envíala para aprobación de Meta",
          line: "Conexión Cloud",
          name: "Nombre",
          nameHint: "minúsculas, números y _",
          nameInvalid: "Debe empezar con letra minúscula y usar solo a-z, 0-9 y _",
          language: "Idioma",
          category: "Categoría",
          headerOptional: "Encabezado — opcional",
          headerFormat: "Tipo de encabezado",
          headerFormats: {
            NONE: "Sin encabezado",
            TEXT: "Texto",
            IMAGE: "Imagen",
            VIDEO: "Video",
            DOCUMENT: "Documento",
          },
          headerText: "Texto del encabezado",
          headerTextHint:
            "Solo texto fijo (máx. 60). Meta no admite variables en el encabezado.",
          headerMediaUrl: "URL de muestra (HTTPS)",
          headerMediaAttach: "Adjuntar archivo",
          headerMediaUploading: "Subiendo…",
          headerMediaEmpty: "Sin archivo de muestra",
          headerMediaUrlHint:
            "Meta exige un archivo de muestra para aprobar encabezados con imagen, video o documento.",
          body: "Cuerpo",
          footerOptional: "Pie — opcional",
          footerText: "Texto del pie",
          buttonsOptional: "Botones — opcional ({{count}}/{{max}})",
          quickReplyButton: "Respuesta rápida",
          addQuickReply: "Respuesta rápida",
          addUrlButton: "Botón URL",
          addPhoneButton: "Botón llamada",
          urlButtonText: "Texto del botón",
          urlButtonUrl: "URL del botón",
          urlButtonUrlHint: "Puedes usar {{1}} al final para un sufijo dinámico.",
          phoneButtonText: "Texto del botón",
          phoneButtonNumber: "Teléfono (E.164)",
          phoneButtonNumberHint: "Ejemplo: +5215512345678",
          quickReplyButtonsHint: "Hasta 3 respuestas rápidas. No se mezclan con botones URL o llamada.",
          ctaButtonsHint: "Hasta 2 botones de acción (URL o llamada). No se mezclan con respuestas rápidas.",
          carouselComingSoon:
            "Las plantillas carrusel estarán disponibles en una próxima versión.",
          addVariable: "+ Agregar variable",
          variableExamplesTitle: "Ejemplos de las variables",
          variableExamplesHint:
            "Meta exige un ejemplo por cada variable. Se usa en la vista previa y al enviar a revisión.",
          variableExamplePlaceholder: "Ejemplo para {{index}}",
          addButton: "Agregar botón",
          authInfo:
            "Las plantillas de autenticación se generan automáticamente (código OTP + recomendación de seguridad). Define solo nombre, idioma y conexión.",
          authTitle: "Plantilla OTP",
          authSubtitle: "Meta generará el mensaje de verificación. Solo configura nombre, idioma y conexión.",
          authSecurityRecommendation: "Incluir recomendación de seguridad",
          authCodeExpiration: "Expiración del código",
          authCodeExpirationOption: "{{minutes}} minutos",
          authCodeExpirationHint: "Meta muestra este tiempo en el pie del mensaje (1–90 min).",
          authPreviewNote: "Vista aproximada. Meta localiza el texto final según el idioma.",
          authPreview: "Meta generará el mensaje OTP automáticamente.",
          authCodeLabel: "Código OTP",
        },
        picker: {
          title: "Enviar mensaje de plantilla",
          subtitle: "Elige una plantilla y completa las variables",
          selectLabel: "Seleccione una plantilla",
          variableLabel: "Variable {{index}}",
          previewTitle: "Vista previa",
          previewEmpty: "Selecciona una plantilla para ver la vista previa.",
          variablesHint:
            "Las variables aparecen como marcadores; el valor real se sustituye en el momento del envío.",
          businessName: "Venttify",
          today: "Hoy",
          send: "Enviar",
          empty: "No hay plantillas aprobadas para esta línea.",
          manageLink: "Gestionar plantillas",
          sent: "Plantilla enviada.",
          scheduled: "Plantilla programada.",
          schedule: "Programar",
          scheduleTitle: "Programar plantilla",
          scheduleAt: "Fecha y hora de envío",
          noLine: "Este ticket no tiene una línea Cloud asociada.",
          paymentRequiredWarning:
            "Los envíos están bloqueados porque falta un método de pago activo en Meta.",
          paymentRequiredAction: "Ver cómo solucionarlo",
        },
        delete: {
          title: "Eliminar plantilla",
          body: "¿Eliminar esta plantilla? Si ya está en Meta, también se solicitará allí.",
        },
        toasts: {
          created: "Plantilla creada como borrador.",
          updated: "Plantilla actualizada.",
          submitted: "Plantilla enviada a Meta para revisión.",
          deleted: "Plantilla eliminada.",
          synced: "Sincronizadas {{count}} plantilla(s) desde Meta.",
        },
        validation: {
          submitBlocked:
            "Corrige estos problemas antes de enviar la plantilla a Meta:",
          title: "Requisitos de Meta",
          template_variable_at_end:
            "La variable no puede ir al final del encabezado, cuerpo o URL. Agrega texto después de {{n}}.",
          template_variable_at_start:
            "La variable no puede ir al inicio del encabezado, cuerpo o URL.",
          template_header_too_many_variables:
            "El encabezado de texto solo admite una variable.",
          template_header_variables_not_allowed:
            "El encabezado no admite variables. Usa solo texto fijo o quita {{n}} del encabezado.",
          template_variable_examples_missing:
            "Define un ejemplo para cada variable antes de guardar o enviar a Meta.",
          template_variables_not_sequential:
            "Las variables deben ser consecutivas: {{1}}, {{2}}, {{3}}… sin saltos.",
          language_normalized_es:
            "El idioma «es» se enviará a Meta como es_MX.",
          language_normalized_en:
            "El idioma «en» se enviará a Meta como en_US.",
          language_normalized_pt:
            "El idioma «pt» se enviará a Meta como pt_BR.",
          template_media_sample_required:
            "Adjunta un archivo de muestra para el encabezado multimedia.",
          template_media_sample_invalid_type:
            "Tipo de archivo no válido para este encabezado.",
        },
        categoryHints: {
          title: "Coherencia con la categoría",
          submitWarningShort:
            "Meta podría reclasificar la categoría de esta plantilla.",
          utility_likely_reclassified:
            "Este contenido podría ser aprobado como Marketing aunque seleccionaste Utilidad.",
          utility_promotional_language:
            "Detectamos lenguaje promocional (oferta, descuento, exclusivo…). Meta suele mover esto a Marketing.",
          utility_sales_cta:
            "Detectamos llamadas a la acción de venta (compra ahora, visita nuestro sitio…).",
          utility_generic_greeting:
            "El saludo parece genérico sin contexto de pedido, cita o cuenta.",
          utility_missing_transaction_context:
            "No encontramos referencia clara a pedido, pago, cita, reserva o cuenta.",
          utility_enthusiastic_tone:
            "El tono parece promocional o entusiasta; Meta es estricto con plantillas de Utilidad.",
          marketing_looks_utility:
            "El texto parece transaccional. Podrías ahorrar costo usando la categoría Utilidad.",
        },
      },
      contactLists: {
        title: "Listas de contactos",
        table: {
          name: "Nombre",
          contacts: "Contactos",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva lista",
        },
        dialog: {
          name: "Nombre",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "¿Desea eliminar esta lista de contactos?",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
        },
        toasts: {
          deleted: "Lista de contactos eliminada correctamente.",
          created: "Lista de contactos creada correctamente."
        },
      },
      contactListItems: {
        title: "Contactos",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nuevo",
          lists: "Volver a las listas",
          import: "Importar",
        },
        dialog: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          okEdit: "Editar",
          okAdd: "Agregar",
          add: "Agregar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nombre",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "Correo electrónico",
          actions: "Acciones",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
          importMessage: "¿Quieres importar contactos desde esta hoja de cálculo? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro eliminado",
        },
      },
      campaigns: {
        title: "Campañas",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nueva campaña",
          contactLists: "Listas de contactos",
        },
        table: {
          name: "Nombre",
          whatsapp: "Conexión",
          contactList: "Lista de contactos",
          status: "Estado",
          scheduledAt: "Programada",
          completedAt: "Completada",
          confirmation: "Confirmación",
          actions: "Acciones",
        },
        dialog: {
          new: "Nueva campaña",
          update: "Editar campaña",
          readonly: "Solo lectura",
          form: {
            name: "Nombre",
            message1: "Mensaje 1",
            message2: "Mensaje 2",
            message3: "Mensaje 3",
            message4: "Mensaje 4",
            message5: "Mensaje 5",
            confirmationMessage1: "Mensaje de confirmacion 1",
            confirmationMessage2: "Mensaje de confirmacion 2",
            confirmationMessage3: "Mensaje de confirmacion 3",
            confirmationMessage4: "Mensaje de confirmacion 4",
            confirmationMessage5: "Mensaje de confirmacion 5",
            messagePlaceholder: "Contenido del mensaje",
            whatsapp: "Conexión",
            status: "Estado",
            scheduledAt: "Programada",
            confirmation: "Confirmación",
            contactList: "Lista de contactos",
            instructions:"Utilice variables como {nombre}, {numero}, {email} o defina variables personalizadas."
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar envío",
            restart: "Reiniciar envío",
            close: "Cerrar",
            attach: "Adjuntar archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Nueva campaña creada con éxito.",
          cancel: "Campaña cancelada",
          restart: "Campaña reiniciada",
          deleted: "Registro eliminado",
        },
      },
      announcements: {
        title: "Boletines",
        searchPlaceholder: "Buscar",
        buttons: {
          add: "Nuevo boletín",
          contactLists: "Listas de noticias",
        },
        table: {
          priority: "Prioridad",
          title: "Título",
          text: "Texto",
          mediaName: "Archivo",
          status: "Estado",
          actions: "Acciones",
          noAttachment:"Sin anexo"
        },
        priority:{
          high:"Alto",
          medium:"Medio",
          low:"Bajo"
        },
        status:{
          active:"Activo",
          inactive:"Inactivo"
        },
        dialog: {
          edit: "Edición del boletín",
          add: "Nuevo boletín",
          update: "Editar boletín",
          readonly: "Solo lectura",
          form: {
            priority: "Prioridad",
            title: "Título",
            text: "Texto",
            mediaPath: "Archivo",
            status: "Estado",
          },
          buttons: {
            add: "Agregar",
            edit: "Actualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Cerrar",
            attach: "Adjuntar archivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage: "¿Estás seguro? Esta acción no se puede revertir.",
        },
        toasts: {
          success: "Operación exitosa",
          deleted: "Registro eliminado",
        },
      },
      campaignsConfig: {
        title: "Configuración de campaña",
      },
      queues: {
        title: "Departamentos",
        table: {
          name: "Nombre",
          color: "Color",
          greeting: "Mensaje de saludo",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar departamentos",
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
           "¿Estás seguro? ¡Esta acción no se puede revertir! Los servicios en esta cola seguirán existiendo, pero ya no tendrán ninguna cola asignada."
        },
        toast:{
          delete: "El departamento se ha eliminado correctamente.",
          create: "Se ha creado el departamento correctamente."
        }
      },
      queueSelect: {
        inputLabel: "Departamentos",
      },
      users: {
        title: "Usuarios",
        table: {
          name: "Nombre",
          email: "Correo electrónico",
          profile: "Perfil",
          actions: "Acciones",
        },
        buttons: {
          add: "Agregar usuario"
        },
        toasts: {
          deleted: "Usuario eliminado exitosamente.",
          cantDeleteYourself:"No puedes eliminar tu propia cuenta"
        },
        confirmationModal: {
          deleteTitle: "Eliminar",
          deleteMessage:
            "Todos los datos del usuario se perderán. Las conversaciones abiertas de este usuario se moverán a la cola.",
        },
      },
      helps: {
        title: "Centro de ayuda",
      },
      schedules: {
        title: "Programar mensajes",
        confirmationModal: {
          deleteTitle: "¿Está seguro de que desea eliminar este mensaje programado?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          contact: "Contacto",
          body: "Mensaje",
          sendAt: "Fecha de programación",
          sentAt: "Fecha de envío",
          status: "Estado",
          actions: "Acciones",
        },
        buttons: {
          add: "Nuevo mensaje",
        },
        toasts: {
          deleted: "Programación eliminada exitosamente.",
        },
      },
      tags: {
        title: "Etiquetas",
        confirmationModal: {
          deleteTitle: "¿Estás seguro de que deseas eliminar esta etiqueta?",
          deleteMessage: "Esta acción no se puede revertir.",
        },
        table: {
          name: "Nombre",
          color: "Color",
          tickets: "Registros etiquetados",
          actions: "Acciones",
        },
        buttons: {
          add: "Nueva etiqueta",
        },
        toasts: {
          deleted: "Etiqueta eliminada correctamente.",
        },
      },
      settings: {
        success: "La configuración se guardó correctamente.",
        title: "Ajustes",
        settings: {
          userCreation: {
            name: "Creación de usuarios",
            options: {
              enabled: "Activado",
              disabled: "Desactivado",
            },
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Asignado a ",
          buttons: {
            return: "Rechazar",
            resolve: "Cerrar",
            reopen: "Reabrir",
            accept: "Aceptar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Mensaje",
        placeholderClosed:
          "Vuelva a abrir o acepte este ticket para enviar un mensaje.",
        signMessage: "firmar",
      },
      contactDrawer: {
        header: "Detalles de contacto",
        channel: "Canal",
        buttons: {
          edit: "Editar contacto",
        },
        channels: {
          whatsapp: "WhatsApp",
          whatsapp_api: "WhatsApp Cloud",
          webchat: "Webchat",
        },
        extraInfo: "Otras informaciones",
      },
      ticketOptionsMenu: {
        schedule: "Programar",
        edit:"Editar",
        delete: "Eliminar",
        transfer: "Transferir",
        markAsUnread: "Marcar como no leído",
        registerAppointment: "Registrar notas",
        appointmentsModal: {
          title: "Notas de contacto",
          textarea: "Observación",
          placeholder: "Ingresa aquí los datos que deseas registrar",
        },
        confirmationModal: {
          title: "Eliminar el chat del contacto #",
          titleFrom: "De",
          message:
            "¡Atención! Se perderán todos los mensajes relacionados con el ticket.",
        },
        buttons: {
          delete: "Eliminar",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Sí, borrar",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Eliminar",
        reply: "Responder",
        edit: "editar",
        downloadImage: "Descargar imagen",
        confirmationModal: {
          title: "Eliminar mensaje?",
          message: "Esta acción no se puede revertir.",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Debe existir al menos una cuenta de WhatsApp predeterminada.",
        ERR_NO_DEF_WAPP_FOUND:
          "No se encontró ninguna cuenta de WhatsApp predeterminada. Revisa la página de conexiones.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sesión de WhatsApp no se ha iniciado. Revisa la página de conexiones.",
        ERR_WAPP_CHECK_CONTACT:
          "No se puede verificar el contacto de WhatsApp. Revisa la página de conexiones.",
        ERR_WAPP_INVALID_CONTACT: "Este no es un número de WhatsApp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "No se pueden descargar medios de WhatsApp. Consulta la página de conexiones.",
        ERR_INVALID_CREDENTIALS:
          "Error de autenticación. Inténtalo de nuevo.",
        ERR_SENDING_WAPP_MSG:
          "Error al enviar mensaje de WhatsApp. Consulta la página de conexiones.",
        ERR_DELETE_WAPP_MSG: "No se puede eliminar el mensaje de WhatsApp.",
        ERR_CLOUD_MESSAGE_ACTION_NOT_SUPPORTED:
          "WhatsApp Cloud API no permite editar ni eliminar mensajes.",
        ERR_OTHER_OPEN_TICKET: "Ya hay un ticket abierto para este contacto.",
        ERR_SESSION_EXPIRED: "Sesión expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "El administrador ha desactivado la creación de usuarios.",
        ERR_NO_PERMISSION: "No tienes permiso para acceder a este recurso.",
        ERR_DUPLICATED_CONTACT: "Ya existe un contacto con este número.",
        ERR_NO_SETTING_FOUND: "No se encontró ninguna configuración con este ID.",
        ERR_NO_CONTACT_FOUND: "No se encontraron contactos con este ID.",
        ERR_NO_TICKET_FOUND: "No se encontraron boletos con esta identificación.",
        ERR_NO_USER_FOUND: "No se encontraron usuarios con este ID.",
        ERR_NO_WAPP_FOUND: "No se encontró ningún WhatsApp con este ID.",
        ERR_CREATING_MESSAGE: "Error al crear mensaje en la base de datos.",
        ERR_CREATING_TICKET: "Error al crear ticket en la base de datos.",
        ERR_FETCH_WAPP_MSG:
          "Error al buscar el mensaje en WhtasApp, quizás sea demasiado antiguo.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Este color ya está en uso. Por favor, elige otro.",
        ERR_QUEUE_NAME_ALREADY_EXISTS:
          "El nombre del departamento ya está en uso. Por favor, elige otro.",
        ERR_WAPP_GREETING_REQUIRED:
          "El mensaje de saludo es obligatorio cuando hay más de un departamento.",
        ERR_QUICKMESSAGE_SHORTCODE_ALREADY_EXISTS: "Este atajo ya existe",
        "Formato invalido, solo se permiten numeros.": "Formato de número inválido",
        outside_window:
          "La ventana de 24 horas de WhatsApp Cloud cerró. Usa una plantilla aprobada para reanudar la conversación.",
        invalid_message_tag:
          "El tag de Messenger no es válido o no está permitido para este envío.",
        messenger_tag_not_allowed_in_window:
          "No puedes usar tags de Messenger mientras la ventana de 24 h está abierta. Envía un mensaje normal.",
        payment_method_required:
          "Envío bloqueado: falta método de pago en Meta. Haz clic para ver cómo solucionarlo.",
        not_on_whatsapp:
          "El número no tiene WhatsApp o no puede recibir mensajes.",
        rate_limited:
          "Meta limitó el envío. Reintenta en unos segundos.",
        whatsapp_messaging_scope_required:
          "Meta no autorizó el envío de mensajes. Vuelve a conectar la línea y acepta todos los permisos de WhatsApp.",
        whatsapp_discovery_scope_required:
          "Faltan permisos de Meta para localizar tu cuenta WhatsApp. Reconecta y acepta business_management y whatsapp_business_management.",
        whatsapp_onboarding_scope_required:
          "Faltan permisos de Meta para registrar la línea Cloud. Reconecta y acepta whatsapp_business_management y whatsapp_business_messaging.",
        whatsapp_cloud_discovery_failed:
          "No se pudo localizar tu cuenta WhatsApp en Meta. Revisa permisos o reconecta la línea.",
        no_whatsapp_business_phone:
          "No se encontró un número de WhatsApp Business asociado a tu cuenta Meta.",
        embedded_signup_assets_missing:
          "Meta completó el registro pero no devolvió la cuenta WhatsApp. Verifica que qa.venttify.com esté en dominios permitidos de la app Meta y vuelve a conectar.",
        whatsapp_cloud_register_failed:
          "No se pudo registrar el número en WhatsApp Cloud API. Revisa permisos Meta o reconecta.",
        whatsapp_cloud_register_pin_invalid:
          "El PIN de WhatsApp Cloud debe ser de 6 dígitos.",
        whatsapp_number_in_use_on_device:
          "Este número sigue activo en WhatsApp Business o personal en un celular. Desvincúlalo, espera 3 minutos y vuelve a conectar.",
        waba_subscription_failed:
          "No se pudo suscribir la app Meta al WABA. Revisa permisos whatsapp_business_management.",
        facebook_code_exchange_failed:
          "No se pudo canjear el código de Meta. Si usaste registro insertado, verifica que Front y Biz usen la misma app Meta.",
        facebook_app_not_configured:
          "WhatsApp Cloud no está configurado en el servidor (FACEBOOK_APP_ID / META_APP_SECRET).",
        facebook_token_invalid:
          "El token de Meta expiró o es inválido. Reconecta la línea en Conexiones.",
        facebook_token_inspection_failed:
          "No se pudo verificar el token de Meta. Reintenta o contacta soporte.",
        session_invalid:
          "La conexión Cloud expiró. Reconecta la línea en Conexiones.",
        graph_unavailable:
          "Meta no respondió. Reintenta más tarde.",
        line_not_ready:
          "La línea Cloud no está lista. Revisa Conexiones.",
        backpressure:
          "Demasiados envíos simultáneos. Espera e inténtalo de nuevo.",
        invalid_to:
          "Número de destino inválido.",
        media_not_found:
          "No se encontró el archivo adjunto.",
        storage_unavailable:
          "Almacenamiento no disponible. Contacta soporte.",
        schedule_window_closed:
          "No se puede programar texto: la ventana de 24 h no cubre la hora elegida. Ajusta la fecha o espera un mensaje del cliente.",
        graph_rejected:
          "Meta rechazó la plantilla. Revisa el texto, las variables y el idioma.",
        template_variable_at_end:
          "La variable no puede ir al final del encabezado o cuerpo. Agrega texto después de {{n}}.",
        template_variable_at_start:
          "La variable no puede ir al inicio del encabezado o cuerpo.",
        template_header_too_many_variables:
          "El encabezado de texto solo admite una variable.",
        meta_template_submit_failed:
          "No se pudo enviar la plantilla a Meta. Revisa el contenido e inténtalo de nuevo.",
        template_media_sample_required:
          "Adjunta un archivo de muestra para el encabezado multimedia.",
        template_media_sample_invalid:
          "No se pudo procesar el archivo de muestra del encabezado.",
        facebook_app_id_required:
          "Falta configurar FACEBOOK_APP_ID en el servicio Meta.",
      },
      ticketComposer: {
        cloudWindow: {
          bannerTitle: "Ventana de 24 h cerrada",
          bannerTitleOpen: "Puedes responder con mensaje libre",
          bannerBodyNoInbound:
            "Por normativa de WhatsApp Cloud, no puedes iniciar el chat con texto o archivos. Envía una plantilla aprobada para contactar al cliente.",
          bannerBodyExpired:
            "Por normativa de WhatsApp Cloud, el chat libre dura 24 h desde el último mensaje del cliente. Ese plazo venció{{expiry}}. Envía una plantilla aprobada para retomar la conversación.",
          bannerBodyOpen:
            "Por normativa de WhatsApp Cloud, puedes enviar mensajes y archivos libres hasta {{expiry}}. Después solo podrás usar plantillas aprobadas.",
          templateButton: "Enviar plantilla",
          templateMenuItem: "Plantilla de mensaje",
          templateComingSoon:
            "El catálogo de plantillas estará disponible pronto. Por ahora solo puedes enviar plantillas desde integraciones.",
        },
        messengerWindow: {
          bannerTitle: "Ventana de 24 h cerrada",
          bannerBodyNoInbound:
            "Por normativa de Messenger, no puedes iniciar el chat con texto libre. Usa un tag de mensaje permitido por Meta para contactar al cliente.",
          bannerBodyExpired:
            "Por normativa de Messenger, el chat libre dura 24 h desde el último mensaje del cliente. Ese plazo venció{{expiry}}. Usa un tag de mensaje para retomar la conversación.",
          bannerBodyOpen:
            "Por normativa de Messenger, puedes enviar mensajes y archivos libres hasta {{expiry}}.",
          splitMediaTextHint:
            "Messenger envía el archivo y el texto como dos mensajes distintos.",
          splitMediaTextHintPending:
            "Escribe un mensaje abajo para enviarlo junto al archivo (como mensaje separado).",
        },
        instagramWindow: {
          bannerTitle: "Ventana de 24 h cerrada",
          bannerBodyNoInbound:
            "Por normativa de Instagram, no puedes iniciar el chat con texto libre. Usa un tag de mensaje permitido por Meta para contactar al cliente.",
          bannerBodyExpired:
            "Por normativa de Instagram, el chat libre dura 24 h desde el último mensaje del cliente. Ese plazo venció{{expiry}}. Usa un tag de mensaje para retomar la conversación.",
          bannerBodyOpen:
            "Por normativa de Instagram, puedes enviar mensajes y archivos libres hasta {{expiry}}.",
          splitMediaTextHint:
            "Instagram envía el archivo y el texto como dos mensajes distintos.",
          splitMediaTextHintPending:
            "Escribe un mensaje abajo para enviarlo junto al archivo (como mensaje separado).",
        },
      },
      messengerTags: {
        modal: {
          openButton: "Enviar con tag",
          title: "Enviar con tag de Messenger",
          subtitle:
            "Fuera de la ventana de 24 h solo puedes enviar con el tag HUMAN_AGENT (requiere permiso aprobado en Meta).",
          policyHint:
            "Meta ya no permite los tags post-compra, evento ni cuenta; usa HUMAN_AGENT para respuestas de agente. El contenido debe cumplir la política de Meta.",
          policyHintInstagram:
            "Fuera de la ventana de 24 h solo está disponible el tag HUMAN_AGENT (requiere permiso aprobado en Meta). El contenido debe cumplir su política.",
          tagLabel: "Tag de mensaje",
          messageLabel: "Mensaje",
          messagePlaceholder: "Escribe el texto del mensaje…",
          cancel: "Cancelar",
          send: "Enviar",
        },
        validation: {
          bodyRequired: "Escribe un mensaje antes de enviar.",
        },
        tags: {
          HUMAN_AGENT: {
            label: "Agente humano (HUMAN_AGENT)",
            hint: "Respuesta de un agente cuando el cliente escribió fuera de la ventana (máx. 7 días). Requiere permiso Human Agent en tu app de Meta.",
          },
        },
      },
      selectChannel: {
        title: "Seleccionar canal"
      },
      webChatModal: {
        title: {
          add: "Agregar WebChat",
          edit: "Editar WebChat"
        },
        form: {
          name: "Nombre",
          greetingMessage: "Mensaje de bienvenida",
          farewellMessage: "Mensaje de despedida",
          outOfHoursMessage: "Mensaje fuera de horario",
          isDefault: "Establecer como predeterminado"
        },
        buttons: {
          okAdd: "Agregar",
          okEdit: "Guardar",
          cancel: "Cancelar"
        },
        success: {
          create: "WebChat creado con éxito!",
          update: "WebChat actualizado con éxito!"
        }
      },
      cloudPaymentRequired: {
        title: "No fue posible enviar el mensaje por WhatsApp",
        intro:
          "Tu cuenta de WhatsApp Business API no tiene un método de pago configurado o activo, por lo que Meta ha bloqueado temporalmente el envío de mensajes.",
        stepsTitle: "Para solucionar el problema:",
        step1: "Accede al Administrador Comercial de Meta.",
        step2: "Ingresa a la sección de facturación.",
        step3: "Agrega o actualiza un método de pago válido.",
        step4: "Verifica que no existan facturas pendientes o pagos rechazados.",
        footer:
          "Una vez completada la configuración, intenta enviar el mensaje nuevamente.",
        billingLink: "Abrir facturación en Meta",
        close: "Entendido",
      },
    },
  },
};

export { messages };
